import { usePJStore } from '@jaf/jaf-react-core';
import { Button } from 'primereact/button';
import React, { useEffect, useState } from 'react';

import {
    IdDeviceBreakpointsByWidth
} from '../../../utils/UtilsResponsive';



function BackBottomButton(props) {

    const getText = usePJStore((state) => state.i18n_getText)
    const [width, setWidth] = useState(window.innerWidth
        || document.documentElement.clientWidth
        || document.body.clientWidth)
    

    const getWidth = () => {
        const width = window.innerWidth
            || document.documentElement.clientWidth
            || document.body.clientWidth;
        return width
    }

    

    useEffect(() => {
        const resizeListener = () => {
            // change width from the state object
            setWidth(getWidth())
          };
          // set resize listener
          window.addEventListener('resize', resizeListener);
      
          // clean up function
          return () => {
            // remove resize listener
            window.removeEventListener('resize', resizeListener);
          }    
    }, []);


    return (
        <>
                <div className="col-12" style={{ height: "5%", textTransform: "uppercase", padding: "2px" }}>
                    <Button onClick={props.handleRootClick} className="p-button-text" size="small" style={{
                         textAlign: width <= IdDeviceBreakpointsByWidth.mobile_max ? 'center' : 'left', width: "100%", textTransform: "uppercase" }} label={getText("GO_BACK")} />
                </div>
            

        </>

    )
}

export default BackBottomButton
